
import { useCallback } from 'react';
import { Handle, Position } from 'reactflow';

function ThanosSidecar({ data }) {
    return (
        <div style={{
            border: "1px solid black", padding: "1.2em"
        }}>
            <span>Thanos Sidecar</span>
        </div>
    );
}

export default ThanosSidecar;

